import React from "react";

const FreeTrialServicesLoader: React.FC = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-gray-800 bg-opacity-75">
      <div className="w-16 h-16 border-2 border-blue-500 rounded-full border-t-transparent animate-spin"></div>
    </div>
  );
};

export default FreeTrialServicesLoader;
